<script setup>
import Layout from "../Layouts/Blank.vue";
import {onMounted} from "vue";

onMounted(() => {
    (function(w, d, s, i) {
        var script = d.createElement(s);
        script.async = true;
        script.src = "//widget.simplybook.pro/v2/widget/widget.js";
        script.onload = function() {
            new SimplybookWidget({"widget_type":"iframe","url":"https:\/\/vigory.simplybook.pro","theme":"default","theme_settings":{"timeline_hide_unavailable":"1","hide_past_days":"0","timeline_show_end_time":"0","timeline_modern_display":"as_slots","sb_base_color":"#aaa5a5","display_item_mode":"block","booking_nav_bg_color":"#d7d4ce","body_bg_color":"#d7d4ce","sb_review_image":"41","sb_review_image_preview":"\/uploads\/vigory\/image_files\/preview\/dace449a0a848d63e1b18d300e894745.png","dark_font_color":"#474747","light_font_color":"#f5fcff","btn_color_1":"#fff053","sb_company_label_color":"#ffffff","hide_img_mode":"1","show_sidebar":"1","sb_busy":"#aaa5a5","sb_available":"#eeebe4"},"timeline":"modern","datepicker":"top_calendar","is_rtl":false,"app_config":{"clear_session":1,"allow_switch_to_ada":0,"predefined":{"provider":"14","service":"94","location":"1","category":"14"}},"container_id":"sbw_6of900"});
        };
        d.head.appendChild(script);
    })(window, document, 'script', 'sbw_6of900');
})
</script>

<template>
    <Layout>
        <div id="sbw_6of900"></div>
    </Layout>
</template>
